import {
    Box,
    MenuItem,
    Select,
    Skeleton,
    useTheme
} from "@mui/material";
import { CustomDropdownBlueIcon } from "../../../../assets/SvgIcons";
import {
    CustomDropdownProps,
    DropdownOption
} from "../types";

export default function CustomDropdown({
    isLoading,
    selectedValue,
    handleValueChange,
    dropdownOptions
}: CustomDropdownProps): JSX.Element {
    const theme = useTheme()

    return (
        <>
            {isLoading && (
                <Skeleton
                    animation='wave'
                    width={200}
                    height={30}
                />
            )}
            {!isLoading && (
                <Box>
                    <Select
                        value={selectedValue}
                        onChange={handleValueChange}
                        sx={{
                            ...theme.typography.body_500,
                            color: theme.palette.primary[500],
                            fontFamily: theme.typography.fontFamily,
                            cursor: 'pointer',
                            padding: "7px 5px",
                            textTransform: "capitalize",
                            "& .MuiSelect-outlined": {
                                padding: "0px 7px",
                            },
                            "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input": {
                                paddingRight: "20px",
                            },
                            "&.Mui-focused": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderWidth: "0",
                                    borderBottom: `1px dashed ${theme.palette.textDark.secondary}`,
                                },
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                marginBottom: 0,
                                borderBottom: `1px dashed ${theme.palette.textDark.secondary}`,
                                borderRadius: 0,
                            },
                        }}
                        IconComponent={CustomDropdownBlueIcon}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    padding: "0px 5px",
                                    borderRadius: "12px",
                                    "& .MuiMenuItem-root": {
                                        padding: "6px",
                                        borderRadius: "8px",
                                        ...theme.typography.body_500,
                                        fontFamily: theme.typography.fontFamily,
                                        color: theme.palette.primary[500],
                                        my: 0.4,
                                        "&.Mui-selected": {
                                            backgroundColor: theme.palette.primary[50],
                                            color: theme.palette.primary[500],
                                        },
                                    },
                                    "& .MuiMenuItem-root:hover": {
                                        backgroundColor: theme.palette.primary[50],
                                        color: theme.palette.primary[500],
                                    },
                                },
                            },
                        }}
                    >
                        {dropdownOptions.map((data: DropdownOption, key: number) => (
                            <MenuItem
                                key={key}
                                value={data.value}
                                sx={{
                                    textTransform: "capitalize",
                                }}
                            >
                                {data?.label?.toLowerCase()}
                            </MenuItem>
                        ))}
                    </Select>
                </Box >
            )
            }
        </>
    )
}